export default __webpack_public_path__ + "static/media/020_photo.367287fa.jpg";